__turbopack_context__.v({
  "billingPeriod": "PrimaryCTA-module__gq8s1q__billingPeriod",
  "buttons": "PrimaryCTA-module__gq8s1q__buttons",
  "ctaAction": "PrimaryCTA-module__gq8s1q__ctaAction",
  "ctaActionMessage": "PrimaryCTA-module__gq8s1q__ctaActionMessage",
  "ctaMessage": "PrimaryCTA-module__gq8s1q__ctaMessage",
  "price": "PrimaryCTA-module__gq8s1q__price",
  "priceDetails": "PrimaryCTA-module__gq8s1q__priceDetails",
  "priceRow": "PrimaryCTA-module__gq8s1q__priceRow",
  "primaryCTA": "PrimaryCTA-module__gq8s1q__primaryCTA",
  "tuitionLabel": "PrimaryCTA-module__gq8s1q__tuitionLabel",
  "tuitionPlaceholder": "PrimaryCTA-module__gq8s1q__tuitionPlaceholder",
  "tuitionSubLabel": "PrimaryCTA-module__gq8s1q__tuitionSubLabel",
});
